import React from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';

const SortItem = (props) => {
  const handleClick = () => props.onClick(props.sortKey);
  return <Button variant="link"
                 className={'text-nowrap ' + (props.isActive ? 'font-weight-bold' : 'text-secondary')}
                 title={props.title}
                 onClick={handleClick}>
    <i className={'icon ' + (props.sortOrders[props.sortKey] > 0 ? 'icon-sort-up' : 'icon-sort-down')}></i> {props.name}
  </Button>
};

SortItem.propTypes = {
  key: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  sortOrders: PropTypes.object.isRequired,
};

export default SortItem;